<template>
    <div>
        <div class="all_inner">
            <h2>实时监控<span class="pull-right">总计：{{total}}台</span></h2>
            <ul class="progress_inner" v-show="select0">          
                <li v-for="(item,index) in monitorList" :key="index">
                    <span class="pull-left">{{item.name}}</span>
                    <el-progress class="pull-left" :percentage="item.percentage" :show-text="false" :stroke-width="7">{{item.value}}</el-progress>
                    <span class="pull-right" style="color:#00fcc9">{{item.value}}</span>
                </li>
            </ul>
            <div class="No" v-show="!select0">
                <img src="../../../static/img/gongxi.png">
                <span style="color: #f5f5f5">恭喜，当前暂无监控设备！</span>
            </div>
        </div>
        <div class="all_inner">
            <h2>实时监测类型告警</h2>
            <div id="Cylind" class="chart" v-show="select1"></div>
            <div class="No" v-show="!select1">
                <img src="../../../static/img/gongxi.png">
                <span style="color: #f5f5f5">恭喜，当前暂无告警设备！</span>
            </div>
        </div> 
        <div class="all_inner">
            <h2>实时报警处理情况</h2>
            <div id="histCahrt" class="chart" v-show="select2"></div>
            <div class="No" v-show="!select2">
                <img src="../../../static/img/gongxi.png">
                <span style="color: #f5f5f5">恭喜，当前告警已全部处理完毕！</span>
            </div>
        </div>           
    </div>
</template>
<script>
    import echarts from 'echarts'
    import { ajaxFuncJson } from '@/api/ajax'
    export default {
        name: 'right',
        data () {
            return {
                CyChart:'', //实时监测类型告警
                hisChart:'', //实时报警处理情况
                monitorList:[
                    {
                      name:'正常',
                      percentage:0,
                      value:0,
                    },
                    {
                      name:'告警',
                      percentage:0,
                      value:0,
                    },
                    {
                      name:'离线',
                      percentage:0,
                      value:0,
                    },
                    {
                      name:'故障',
                      percentage:0,
                      value:0,
                    },        
                ],//实时报警处理情况数据      
                total: 0,//实时监控总计
                cxdata:['电气', '水压', '液位', '烟感','可燃气','灭火器'],//实时监测类型告警X轴标题
                cydata:[],//实时监测类型告警Y轴值
                dataList:[
                    {value:0, name:'待处理'},
                    {value:0, name:'处理中'},
                    {value:0, name:'审核中'},
                ],//实时报警处理情况数据
                select0: true,
                select1: true,
                select2: true,
            }
        },
        created() {
            // this.getMonitor();  //获取实时监控、实时监测类型告警数据
            this.getAlarmNotice();  //获取实时报警处理情况图表
        },
        mounted() {
            this.drawCylind();
            this.histogram();
        },
        methods:{
            //获取实时监控、实时监测类型告警数据
            getMonitor(){
              if(this.isAuth('common:interface')){
                let params = {
                  customerId: sessionStorage.getItem('customerId'),
                  buildingId: sessionStorage.getItem('buildId'),
                  pageType :0
                }
                ajaxFuncJson('/monitoring/realTimeMonitoring',params).then(res=>{
                  if(res.data.status == 200){
                    this.total=res.data.data.total;
                    this.cydata=[];
                    let electric = res.data.data.realTimeTypeAlarm.electric;
                    let water = res.data.data.realTimeTypeAlarm.water;
                    let liquid = res.data.data.realTimeTypeAlarm.liquid;
                    let somke = res.data.data.realTimeTypeAlarm.somke;
                    let gas = res.data.data.realTimeTypeAlarm.gas;
                    let fire = res.data.data.realTimeTypeAlarm.fire;
                    for (let key=0;key<6;key++){
                      if(key===0){
                        this.cydata.push(res.data.data.realTimeTypeAlarm.electric)
                      }else if(key===1){
                        this.cydata.push(res.data.data.realTimeTypeAlarm.water)
                      }else if(key===2){
                        this.cydata.push(res.data.data.realTimeTypeAlarm.liquid)
                      }else if(key===3){
                        this.cydata.push(res.data.data.realTimeTypeAlarm.somke)
                      }else if(key===4){
                        this.cydata.push(res.data.data.realTimeTypeAlarm.gas)
                      }else if(key===5){
                        this.cydata.push(res.data.data.realTimeTypeAlarm.fire)
                      }
                    }
                    if(electric == 0 && water == 0 && liquid == 0 && somke == 0 && gas == 0 && fire == 0){ //新增为0判断
                        this.select1 = false;
                    } else {
                        this.select1 = true;
                    }
                    let a = 1;
                    for(let i=0;i<res.data.data.realTimeStatus.length;i++){
                      if(this.total == 0){
                        this.monitorList[i].percentage = 0;
                        this.monitorList[i].value = 0;
                      }else{
                        this.monitorList[i].value=res.data.data.realTimeStatus[i];
                        this.monitorList[i].percentage=res.data.data.realTimeStatus[i]/this.total*100;
                      }
                     if(res.data.data.realTimeStatus[i] != 0){ //新增为0判断
                          a = 2;
                      }
                    }
                    if(a == 1){
                        this.select0 = false;
                    }else{
                         this.select0 = true;
                    }
                    this.drawCylind();
                  }
                });
              }
            }, 
            //获取实时报警处理情况图表
            getAlarmNotice(){
                if(this.isAuth('common:interface')) {
                    let params = {
                        customerId: sessionStorage.getItem('customerId'),
                        buildingId: sessionStorage.getItem('buildId'),
                        pageType :0
                    }
                    ajaxFuncJson('/alarmNoticeRecord/realTimeMonitoringDeal',params).then(res=>{
                        if(res.data.status==200){
                            let b = 1;
                            for(let i = 0; i < res.data.data.dealArr.length; i++){
                                this.dataList[i].value=res.data.data.dealArr[i];
                               if(res.data.data.dealArr[i] !=0){ //新增为0判断
                                   b = 2;
                                }
                                this.histogram();
                            }
                            if(b == 1){
                                this.select2 = false;
                            }else{
                                this.select2 = true;
                            }
                        }
                    });
                }
            },       
            //实时监测类型告警柱状图
            drawCylind(){
                // 基于准备好的dom，初始化echarts实例
                this.cyChart = this.$echarts.init(document.getElementById('Cylind'))
                // 绘制图表
                this.cyChart.setOption({
                  title: {
                      text: '个',
                      //标题字体样式
                      textStyle: {
                        color: '#66b3ff',
                        fontSize: '13',
                        align: 'left',
                        lineHeight:'35',
                      }         
                  },
                  color: ['#00ffca'],
                  tooltip : {
                      trigger: 'axis',
                      axisPointer : {            // 坐标轴指示器，坐标轴触发有效
                          type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                      },
                      textStyle:{
                        fontSize:13,
                        color:['#66b3ff'],                
                      },
                      backgroundColor: ['rgba(0,0,0,.6)'], 
                      padding: 10,
                  },
                  grid: {
                      left: '0%',
                      right: '0%',
                      top:'22%',
                      bottom: '10%',
                      containLabel: true
                  },
                  xAxis : [
                      {
                          type : 'category',
                          data : this.cxdata,
                          axisTick: {
                              show: false,//显示隐藏刻度
                              alignWithLabel: true
                          },
                          //设置坐标轴字体颜色和宽度
                          axisLine: {
                              lineStyle: {
                                  color: "#66b3ff",
                              }
                          },           
                      }
                  ],
                  yAxis : [
                      {
                          type : 'value',
                          //设置坐标轴字体颜色和宽度
                          axisLine: {
                              lineStyle: {
                                  color: "#66b3ff",
                              }
                          },
                          axisTick: {
                              show: false,//显示隐藏刻度
                          },                  
                          //网格样式
                          splitLine: {
                              show: true,
                              lineStyle:{
                                  color: ['#666'],
                                  width: 1,
                                  type: 'solid'
                              }
                          }                  
                      },
                  ],
                  series : [
                      {
                          name:'',
                          type:'bar',
                          barWidth: '16%',
                          data:this.cydata,
                      }
                  ]          
                });
            },
            // 实时报警处理情况图表
            histogram() {
                const _dataList=this.dataList;
                this.hisChart = echarts.init(document.getElementById('histCahrt'));
                this.hisChart.setOption({
                  tooltip: {
                      trigger: 'item',
                      formatter: "{a} <br/>{b}: {c} ({d}%)",
                      textStyle:{
                        fontSize:13,
                        color:['#66b3ff'],
                      },
                      backgroundColor: ['rgba(0,0,0,.6)'], 
                      padding: 10,
                  },
                  color:['#06d0b3','#00a0f5','#fc6900',],
                  legend: {
                      orient: 'vertical',
                      x: 'left',
                      data:this.dataList.name,
                      y:'center',
                      left: '16%',
                      bottom: '23%',
                      icon:'rect',
                      itemWidth:10,
                      itemHeight:10,
                      formatter:function(name){
                          let target;
                          for(let i = 0;i <_dataList.length; i++){
                              if(_dataList[i].name === name){
                                  target = _dataList[i].value
                              }
                          }
                          let arr = ["{a|"+name+' :'+"}","{b|"+target+"}"];
                          return arr.join("    ")
                      },
                      textStyle:{
                          fontSize:13,
                          lineHeight:20,
                          rich: {
                              a: {
                                  color: '#198cff',
                              },
                              b: {
                                  color: '#00fcc9',    
                              }
                          } 
                      },
                  },
                  series: [
                      {
                          name:'实时报警处理情况',
                          type:'pie',
                          radius: ['30%', '40%'],
                          center: ['70%', '50%'],
                          avoidLabelOverlap: false,
                          label: {
                              normal: {
                                  show: false,
                                  position: 'center'
                              },
                              emphasis: {
                                  show: false
                              }
                          },
                          labelLine: {
                              normal: {
                                  show: false
                              }
                          },
                          data:this.dataList,
                      }
                  ]                  
                });
            },    
        },
    }
</script>
<style lang="scss" scoped>
    .chart{
      width: 100%;
      height: 214px;
    }
    .all_inner {
        position: relative;
        span {
            color: #66b3ff;
        }
    }
    @media screen and (max-width: 1366px) {
      .chart{
        height: 156px;
      }
    }
</style>



// WEBPACK FOOTER //
// src/page/home/right.vue